<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>租赁管理 </el-breadcrumb-item>
      <el-breadcrumb-item>单元管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.unitName" placeholder="输入单元名称"></el-input>
      </el-form-item>

      <el-form-item v-if="user.username == 'admin'" label="选择部门">
         <el-select v-model="formInline.depId" placeholder="请选择部门"  size="small">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.departmentName"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handelAdd">添加</el-button>
      </el-form-item>

    </el-form>

   <el-table  :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
    style="width: 100%;"  stripe :max-height="tableHeight">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column  prop="unitName" label="单元名称" show-overflow-tooltip>

      </el-table-column>



    	<el-table-column  prop="layers" label="楼层" show-overflow-tooltip>
      </el-table-column>

     <el-table-column align="center" label="操作" width="350">
        <template slot-scope="scope">
       <!--   <prems-button size="mini"   perms="p:detail" @click="handleEdit(scope.row)" label="编辑" />
          <prems-button size="mini" type="danger"  perms="p:delete" @click="deleteInfo(scope.row)" label="删除" /> -->
          <el-button size="mini" type="primary" @click="showAllRooms(scope.row)">查看房间</el-button>
          <el-button size="mini" type="success" @click="handelAddRooms(scope.row)">添加房间</el-button>
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger"    @click="deleteInfo(scope.row)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="formInline" @callFather="callFather" v-if="showPage"></Pagination>



    <el-dialog :title="title" :visible.sync="editFormVisible" width="35%" @click="editFormVisible = false" :close-on-click-modal="false">
    	<el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="选择部门">
           <el-select v-model="editForm.departmentId" placeholder="请选择部门"  size="small">
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
    		<el-form-item label="单元名称" prop="unitName">
    			<el-input size="small" v-model="editForm.unitName" auto-complete="off" placeholder="请输入单元名称"></el-input>
    		</el-form-item>
    		<el-form-item label="楼层数" prop="layers">
    			<el-input size="small" v-model="editForm.layers" type="number" auto-complete="off" placeholder="请输入楼层数"></el-input>
    		</el-form-item>



    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="editFormVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitForm('editForm')">保存</el-button>
    	</div>
    </el-dialog>



    <el-dialog title="查看详情" :visible.sync="unitVisible" width="95%" @click="unitVisible = false" :close-on-click-modal="false">

      <div style="text-align: center;padding: 40px 0;" v-if="floolDataList.length == 0">
        <img src="../../assets/img/empty.png" />
        <p>暂无数据</p>
      </div>
      <div class="unitList">
        <div class="floolList clearfix" v-for="item in floolDataList">
          <div  >

            <h2 style="margin-left: 10px; display: inline-block;">{{item.floor}}层</h2>
            <el-button @click="handelAddRoomInner(item.floor)" type="primary" size="mini" style="position: relative;top: -4px;margin-left: 20px;">添加房间</el-button>
          </div>
          <el-card class="box-card" v-for="sitem in item.roomList">
            <div slot="header" class="clearfix">
              <el-tag type="success" size="small">{{sitem.roomName}}</el-tag>
              <div style="float: right;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                   <i style="font-size: 20px;" class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  >
                      <div @click="detailRoom(sitem,item.floor)">编辑房间</div>

                    </el-dropdown-item>

                    <el-dropdown-item  >
                        <div @click="delRoom(sitem)">删除房间</div>
                     </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>

            </div>
            <div class="text item">承租人：{{sitem.user}}</div>
            <div class="text item">租金：{{sitem.rent}}</div>
            <div class="text item">管理费：{{sitem.expensesFee}}</div>
            <div class="text item">电梯费：{{sitem.elevatorFee}}</div>
            <div class="text item">卫生费：{{sitem.sanitationFee}}</div>

          </el-card>

        </div>



      </div>

    </el-dialog>



    <el-dialog :title="roomTitle" :visible.sync="roomVisible" width="35%" @click="roomVisible = false" :close-on-click-modal="false">
    	<el-form label-width="120px" :model="roomEditFrom" :rules="roomRules" ref="roomEditFrom">

    		<el-form-item label="房间名称" prop="roomName">
    			<el-input size="small" v-model="roomEditFrom.roomName" auto-complete="off" placeholder="请输入房间名称"></el-input>
    		</el-form-item>
    		<el-form-item label="房间大小(㎡)" prop="roomArea">
    			<el-input size="small" v-model="roomEditFrom.roomArea" type="number" auto-complete="off" placeholder="请输入房间大小"></el-input>
    		</el-form-item>

        <el-form-item  label="选择计量点" prop="meterInfoIds">
          <el-select multiple @change="getMeterIds"  filterable v-model="meterInfoIds" placeholder="请选择计量点"  size="small" style="width: 100%;">
             <el-option
                v-for="item in meterList"
                :key="item.id"
                :label="item.meterPointName"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>


        <el-form-item  label="选择楼层" prop="floor">
          <el-select  filterable v-model="roomEditFrom.floor" placeholder="请选择选择楼层"  size="small" >
             <el-option
                v-for="item in floolList"
                :key="item"
                :label="item+1+'层'"
                :value="item+1">
              </el-option>
            </el-select>
        </el-form-item>

    	</el-form>
    	<div slot="footer" class="dialog-footer">
    		<el-button size="small" @click="roomVisible = false">取消</el-button>
    		<el-button size="small" type="primary" :loading="setLoading" class="title" @click="submitRoomForm('roomEditFrom')">保存</el-button>
    	</div>
    </el-dialog>




  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  import { getDepartmentTerminalInfoLis,getDepartmentIdByMeterInfos} from '../../api/energyMG'
  import {
    findAllMeterInfoList,
    deleteRoom,
    addRoom,
    findAllRoomList,
    updateRoom,
    roomRecharge,
    generateWaterAndPropertyMonthlyBill,
    roomRefund,
    unitAdd,
    getUnitList,
    unitDelete,
    unitUpdate,
    findRentRoomList,
    addRentRoom,
    modifyRentRoom,
    deleteRentRoom,


  } from '../../api/payMG.js'

  export default {
    data() {


      return {
        formInline: {
          depId:"",
          pageSize:10,
          currentPage:1,
          total:0,
          unitName:"",
        },
        roomTitle:"",
        floolList:[],
        unitVisible:false,
        saveLoad:false,
        totalFee:"",
        users:[],
        editForm:{
          departmentId:"",
          unitName:"",
          layers:"",
        },
        roomEditFrom:{
          depId:"",
          roomName:"",
          roomArea:"",
          meterInfoIds:"",
          unitId:"",
          floor:""
        },
        roomVisible:false,
        floolDataList:[],

        meterList:[],

        roomParm:{
          depId:"",
          unitId:""
        },
        meterInfoIds:[],
        rtitle:"",
        rechargeFormVisible:false,
        setLoading:false,
        tableHeight:0,
        title:"",
        loading:false,
        meterPointName:"",
        editFormVisible:false,
        dataList:[],
        deptList:[],
        user:{},
        showPage:true,
        reditForm: {
        	totalFee:"",
        	appletUserId:'',
          roomId:"",
        	mark:"",
          roomType:"63",
          payType:'2',
        },

        money:{
          water:'',
          wuYe:"",
        },

        rules: {
        	unitName: [{required: true,message: '请输单元名称',trigger: 'blur'}],
          layers: [{required: true,message: '请输入单元楼层',trigger: 'blur'}],
          meterInfoId: [{required: true,message: '请输入房间大小',trigger: 'change'}],

        	// roomNum:[{validator:validatePass,trigger:'change' }]

        },

        roomRules:{
          roomName:[{required: true,message: '请输房间名称',trigger: 'blur'}],
          roomArea:[{required: true,message: '请输房间大小',trigger: 'blur'}],
          meterInfoIds:[{required: true,message: '请选择计量点',trigger: 'change'}],
          floor:[{required: true,message: '请选择楼层',trigger: 'change'}],
        },
      }
    },
    mounted(){
      this.$nextTick(() => {
      	this.tableHeight = window.innerHeight - 300
      })
    },
    created(){
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      if(this.user.username != 'admin'){
         this.formInline.depId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
         this.editForm.departmentId = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      }

      this.getJzData()
      this.getData()






    },
    components: {
      Pagination,
      PremsButton
    },
    methods:{
      submitRoomForm(){

        this.$refs['roomEditFrom'].validate(valid => {

        	if(valid){
            if(this.roomTitle == '编辑房间'){
              this.updateRoom()
            }else{
              this.saveRoom()
            }
          }
        })




      },

       delRoom(row){
         this.$confirm('确定要删除吗?', '信息', {
         		confirmButtonText: '确定',
         		cancelButtonText: '取消',
         		type: 'warning'
         	})
         	.then(() => {
         		// 删除
         		deleteRentRoom({
         				id: row.id
         			})
         			.then(res => {
         				if (res.status == 1) {
         					this.$message({
         						type: 'success',
         						message: '已删除!'
         					})
         					this.getRoomList()
         				} else {
         					this.$message({
         						type: 'info',
         						message: res.msg
         					})
         				}
         			})
         			.catch(err => {
         				this.loading = false
         				this.$message.error('删除失败，请稍后再试！')
         			})
         	})
         	.catch(() => {
         		this.$message({
         			type: 'info',
         			message: '已取消删除！'
         		})
         	})
       },


      detailRoom(data,floor){
        console.log(data)
        this.roomVisible = true
        this.roomTitle = '编辑房间'
        this.roomEditFrom.roomName = data.roomName
        this.roomEditFrom.roomArea = data.roomArea
        this.roomEditFrom.meterInfoIds = data.meterNames.map( item => item.meterId).join(',')
        this.roomEditFrom.depId  = data.depId
        this.roomEditFrom.id = data.id
        this.roomEditFrom.floor = floor


        this.meterInfoIds = data.meterNames.map( item => item.meterId)

      },

      updateRoom(){

        modifyRentRoom(this.roomEditFrom).then(res => {
          if(res.status == 1){
            this.roomVisible = false
            this.$message.success("操作成功")
            this.getRoomList();
          }else {
            this.$message.error(res.msg)
          }
        })
      },

      saveRoom(){
        addRentRoom(this.roomEditFrom).then(res => {
          if(res.status == 1){
            this.roomVisible = false
            this.$message.success("操作成功")
             this.getRoomList();
          }else {
            this.$message.error(res.msg)
          }
        })
      },


      handelAddRooms(row){
        this.roomTitle = '添加房间'
        this.roomEditFrom.id = ''
        this.roomVisible = true
        this.getMeterList(row.departmentId)
        this.roomEditFrom.depId = row.departmentId
        this.roomEditFrom.unitId = row.id

       this.roomEditFrom.roomName = ""
       this.roomEditFrom.roomArea = ""
       this.meterInfoIds = []
        let arr = []
        for(let i = 0;i<row.layers;i++){
          arr.push(i)
        }
        this.floolList = arr
      },
      getMeterIds(){
        this.roomEditFrom.meterInfoIds = this.meterInfoIds.join(',')
      },


      handelAddRoomInner(floor){
         this.roomTitle = '添加房间'
         this.roomEditFrom.id = ''
         this.roomEditFrom.roomName = ""
          this.meterInfoIds = []
         this.roomEditFrom.roomArea = ""
         this.roomEditFrom.floor = floor
         this.roomVisible = true

      },




      getMeterList(id){
        getDepartmentIdByMeterInfos({depId:id}).then(res => {
        	if(res.status == 1){
        		this.meterList = res.data

        	}else{
        		this.loading = false
        		this.$message.error(res.msg)
        	}
        })
        .catch( err =>{
        	this.loading = false
        	this.$message.error(err)
        })
      },
      showAllRooms(row){
        this.unitVisible = true
        this.roomEditFrom.depId = row.departmentId
        this.roomEditFrom.unitId = row.id
        this.getMeterList(row.departmentId)

        this.roomParm.depId = row.departmentId,
        this.roomParm.unitId = row.id



        let arr = []
        for(let i = 0;i<row.layers;i++){
          arr.push(i)
        }
        this.floolList = arr

        this.getRoomList()




      },

      getRoomList(){
        findRentRoomList(this.roomParm).then(res => {
          if( res.status == 1 ){
            this.floolDataList = res.data.data
          }
        })
      },


      changeType(e){
        if(this.reditForm.roomType == '63'){
          this.dForm.blance = this.money.water
        }else{
           this.dForm.blance = this.money.wuYe
        }
      },



      getData(){
        this.loading = true
        getUnitList(this.formInline).then(res => {
          this.loading = false
          if(res.status == 1){
            this.dataList = res.data.data
            this.formInline.total = res.data.totalCount

          }else{
            this.$message.error(res.msg)
          }
        })
      },
      handelAdd(){
        this.editFormVisible = true
        this.title = '添加'
        this.editForm.id = ""
        this.editForm.unitName = ''
        this.editForm.layers  = ''
        this.editForm.departmentId = ''
      },

      handleEdit(row){
        this.title = '编辑'

        this.editFormVisible = true
        this.editForm.id = row.id
        this.editForm.departmentId = row.departmentId
        this.editForm.unitName = row.unitName
        this.editForm.layers = row.layers

      },
      search(){
        this.getData()
      },
      callFather(parm){
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      deleteInfo(row){
        this.$confirm(' 确定要删除吗?', '信息', {
        		confirmButtonText: '确定',
        		cancelButtonText: '取消',
        		type: 'warning'
        	})
        	.then(() => {
        		// 删除
        		unitDelete({
        				id: row.id,

        			})
        			.then(res => {
        				if (res.status == 1) {
        					this.$message({
        						type: 'success',
        						message: '已删除!'
        					})
        					this.getData()
        				} else {
        					this.$message({
        						type: 'info',
        						message: res.msg
        					})
        				}
        			})

        	})
        	.catch(() => {
        		this.$message({
        			type: 'info',
        			message: '已取消删除！'
        		})
        	})
      },
      getMeterInfoList() {
      	this.loadMeter = true
      	let param = {
      		meterPointName: this.meterPointName,
      		energyType:15,
      		priceConfigId:this.curPriceId
      	}
      	findAllMeterInfoList(param).then(res => {
      		this.loadMeter = false
      		if (res.status == 1) {

      			this.MeterInfoList = res.data

      			//this.setChoisMeter(row)
      		} else {
      			this.$message({
      				type: 'info',
      				message: res.msg
      			})
      		}
      	})
      	.catch(err => {
      		this.loadMeter = false
      		this.$message.error('获取数据失败，请稍后再试！')
      	})

      },
      getJzData:function(){
      	return new Promise((resolve,reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if(res.status == 1){
      				let arr = []
      				this.deptList = res.data.menuDepList
              res.data.terIds.forEach( item => {
              	arr.push({ id: item})
              })
              // this.mForm.terIds = JSON.stringify(arr)
              // this.getMeterList();
      			}
      			else{
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },



      submitForm(){

        this.$refs['editForm'].validate(valid => {

        	if(valid){
            if(this.title == '添加'){
              this.add()
            }else{
              this.update()
            }
          }
        })


      },

      add(){
        unitAdd(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      },
      update(){
        unitUpdate(this.editForm).then(res => {
          if(res.status == 1){
            this.editFormVisible = false
            this.$message.success("操作成功")
            this.getData();
          }else {
            this.$message.error(res.msg)
          }
        })
      }
    }
  }
</script>

<style scoped>
  .box-card {
    width: 240px;
    float: left;
    margin: 10px;
  }
   .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both
    }


</style>



// WEBPACK FOOTER //
// src/views/property/unit.vue